export const GET_SECTIONS = 'GET_SECTIONS';
export const GET_SECTIONS_SUCCESS = 'GET_SECTIONS_SUCCESS';
export const GET_SECTIONS_FAILURE = 'GET_SECTIONS_FAILURE';

export const GET_SECTION = 'GET_SECTION';
export const GET_SECTION_SUCCESS = 'GET_SECTION_SUCCESS';
export const GET_SECTION_FAILURE = 'GET_SECTION_FAILURE';

export const GET_SECTION_AND_START = 'GET_SECTION_AND_START';



// WEBPACK FOOTER //
// ./src/redux/actions/sectionsActionTypes.js